<div class="row row--primary">
  <div class="col-12 pl-0 pr-0">
    <web-components-user-notes target="order-create" [dismissibleNotes]="true" />
  </div>
</div>
<div class="row row--primary tile d-block" [zeroLoadingIndicator]="facade.validating$ | async">
  <h1 class="zero-text p-bigger-bold" data-zid="multi-order-create-headline">{{ 'trade.multi-order.create.headline' | transloco }}</h1>
  <p data-zid="multi-order-create-text">{{ 'trade.multi-order.create.text' | transloco }}</p>
  <trade-multi-order-create-buy-list [instruments]="instruments" />
  <hr />
  <trade-multi-order-create-sell-list [instruments]="instruments" />
  <hr />
  <trade-multi-order-summary />
  @if ((facade.loadingMultiOrderInstruments$ | async) === false) {
    <trade-multi-order-error [errors]="facade.multiOrderErrors$ | async" />
  }
  <div class="row mt-4 mb-2">
    <div class="col">
      <web-design-system-button
        type="primary"
        [fullwidth]="true"
        data-zid="multi-order-create-btn"
        [disabled]="(facade.validForm$ | async) === false"
        (click)="facade.validateMultiOrder()"
      >
        {{ 'trade.multi-order.create.btn' | transloco }}
      </web-design-system-button>
    </div>
  </div>
</div>
